import { WebsiteConfiguration } from '@cineamo/api/models/website-configuration/WebsiteConfiguration.types';

export type ExternalLinkTargetProps = {
    target: '_blank' | '_self';
    rel: string | undefined;
};

/**
 * Resolves the `target`/`rel` props for a link that points to another domain (cinema links,
 * footer links, partner links, shop links, social media icons, description links, …), honoring
 * the cinema's `externalLinksTarget` preference. Unset defaults to `new-tab`, the behavior every
 * external link on the website used before this setting existed.
 *
 * Only call this for hrefs that actually point to another domain — internal/relative links keep
 * their existing (same-tab) behavior and should not go through this helper.
 */
export function getExternalLinkTarget(websiteConfiguration?: WebsiteConfiguration): ExternalLinkTargetProps {
    const opensInNewTab = (websiteConfiguration?.externalLinksTarget ?? 'new-tab') === 'new-tab';

    return opensInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : { target: '_self', rel: undefined };
}
